import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faArrowCircleLeft,  faBackward,  faPause,} from '@fortawesome/free-solid-svg-icons';
import {  faCircle} from '@fortawesome/free-regular-svg-icons'
import './Home.css'
import LoadModel from '../FetchModel/LoadModel';
export class Home extends Component {
    videoEle = React.createRef();
    canvasEle = React.createRef();
    imageEle = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            fruit: '',
            Cameras: 1,
            currentFacingMode: '',
        };
    }
    componentDidMount = async () => {
        this.state.Cameras = ((await navigator.mediaDevices.enumerateDevices()).filter(device => device.kind === 'videoinput')).length
        this.state.currentFacingMode = (this.state.Cameras > 1) ? 'environment' : 'user';
        this.startCamera(this.state.currentFacingMode);
    }
    
    //Stop Camera
    stopCam = () => {
        const stream = this.videoEle.current.srcObject;
        const tracks = stream.getTracks();

        tracks.forEach(track => {
            track.stop();
        });
    }
    changeCam = async () => {
        this.stopCam();
        (this.state.currentFacingMode === 'user') ? this.startCamera('environment') : this.startCamera('user');
        
    }
    //Start Camera 
    startCamera = async (CameraFacingMode = 'user') => {
        try {
            this.state.currentFacingMode = CameraFacingMode;
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    // width: {
                    //     min: 1280,
                    //     ideal: 1920,
                    //     max: 2560,
                    // },
                    // height: {
                    //     min: 720,
                    //     ideal: 1080,
                    //     max: 1440
                    // },
                    facingMode: CameraFacingMode
                    // ,
                    // whiteBalanceMode: false,
                    // colorTemperature: false,
                    //   facingMode: {
                    //       exact: 'environment'
                    //   }
                }
            });
            // console.log(stream.getTracks())
            //Set Camera Constriants audio: true to also listen for audio
            this.videoEle.current.srcObject = stream;

        } catch (err) {
            console.log(err);
        }
    }

    //Capture
    Capture = async () => {
        // Get the exact size of the video element.
        const width = this.videoEle.current.videoWidth;
        const height = this.videoEle.current.videoHeight;

        // get the context object of hidden canvas

        const ctx = this.canvasEle.current.getContext('2d');

        // Set the canvas to the same dimensions as the video.
        this.canvasEle.current.width = width;
        this.canvasEle.current.height = height;

        // Draw the current frame from the video on the canvas.
        ctx.drawImage(this.videoEle.current, 0, 0, width, height);
        const MainCanvas = document.getElementById('Main_Canvas')
        MainCanvas.style.display = 'flex '
        const ButtonContainer = document.getElementById('ButtonContainer')
        ButtonContainer.style.display = 'none'
        const BackToCamButton = document.getElementById('PostCaptureBackToCameraButton');
        BackToCamButton.style.display = 'flex'
        let list = ['Apple rotten',
            'apple6',
            'apple_braeburn',
            'Crimson Apple',
            'apple_golden_1',
            'apple_golden_2',
            'apple_golden_3',
            'Granny Smith Apple',
            'apple_hit',
            'apple_pink_lady',
            'apple_red_1',
            'apple_red_2',
            'apple_red_3',
            'Apple Red Delicios',
            'Apple Red Yellow']
        const finalValue = await LoadModel(this.canvasEle.current);
        // this.setState(list[finalValue])
        // console.log(finalValue)
        const quality = document.getElementById('quality')
        quality.innerText = list[finalValue]
        // this.state.fruit = list[finalValue]
        // Get an image dataURL from the canvas.
        // const imageDataURL = this.canvasEle.current.toDataURL('image/png');

        // Set the dataURL as source of an image element, showing the captured photo.
        // this.stopCam();
        // this.setState({
        //     imageURL: imageDataURL
        // })
    }
    //Back To Camera
    backToCam = () => {
        this.startCamera();
        const canvas = document.getElementById('Main_Canvas')
        canvas.style.display = 'none'
        const ButtonContainer = document.getElementById('ButtonContainer')
        ButtonContainer.style.display = 'flex'
        const BackToCamButton = document.getElementById('PostCaptureBackToCameraButton');
        BackToCamButton.style.display = 'none'
    }
    render() {


        return (
            <div className='Main_Container'>
                <div id='Main_Canvas'>
                    <canvas ref={this.canvasEle} className='Image'></canvas>
                    <h2 className='Text' id='quality'>  </h2>
                </div>
                <div className='Video_Section'>
                    <video width="100%" height="100%" className="video-player" autoPlay={true} ref={this.videoEle}></video>
                </div>
                <div className='Button_Container' id='ButtonContainer'>
                    <span className='Stop_Button' id='StopCameraButton' onClick={this.stopCam} ><FontAwesomeIcon icon={faPause} size="1x" className='btn-icon' /></span>
                    <span className='Capture_Button' id='CaptureButton' onClick={this.Capture} ><FontAwesomeIcon icon={faCircle} size="3x" className='btn-icon'/></span>
                    <span className='Change_Cam_Button' onClick={this.changeCam} ><FontAwesomeIcon icon={faBackward} size="1x" className='btn-icon' /></span>
                </div>
                <div className='Button_Container' id='PostCaptureBackToCameraButton' style={{
                    display: 'none',
                    margin: '0.3rem'
                }}>
                    <span id='BackToCameraButton' onClick={this.backToCam} ><FontAwesomeIcon icon={faArrowCircleLeft} size="2x" className='Back_Button' /></span>
                </div>
            </div>
        )
    }
}

export default Home
